import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { http } from "@/lib/api";
import { BriefDialog } from "@/components/chat/BriefDialog";
import { Message } from "@/components/chat/Message";
import { CeresMark } from "@/components/ceres/CeresMark";

export default function SharePage() {
  const { id } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    http.get(`/share/${id}`).then(({ data }) => setDoc(data)).catch(() => setError(true));
  }, [id]);

  return (
    <div className="min-h-screen bg-hv-section" data-testid="share-page">
      <header className="hv-hero text-white">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-5 py-5">
          <Link to="/" className="inline-flex items-center gap-3 bg-white px-3 py-2" data-testid="share-home-link">
            <img src="/brand/etf-header.svg" alt="Harvest ETFs" className="h-5 w-auto" />
          </Link>
          <div className="flex items-center gap-2">
            <CeresMark size={34} tone="dark" />
            <span className="font-heading text-lg font-extrabold tracking-[0.14em]">CERES</span>
          </div>
        </div>
        <div className="mx-auto max-w-3xl px-5 pb-8">
          <p className="font-heading text-[11px] font-semibold uppercase tracking-[0.28em] text-hv-orange">Shared answer</p>
          {doc && <h1 className="mt-2 font-heading text-2xl font-bold leading-snug sm:text-3xl" data-testid="share-question">{doc.question}</h1>}
          {doc && <p className="mt-2 text-[13px] text-white/70">Answered by Ceres on {doc.created_at.slice(0, 10)}. Figures are as at the dates shown and may have changed since.</p>}
        </div>
      </header>
      <main className="mx-auto max-w-3xl px-5 py-8">
        {error && <p className="bg-white p-5 text-[14px] text-hv-text" data-testid="share-not-found">This shared answer is not available.</p>}
        {doc && (
          <div className="bg-white p-5 sm:p-7">
            <Message msg={{ id: doc.id, role: "assistant", text: doc.answer, components: doc.components || [], sources: doc.sources || [] }} lang={doc.lang} readOnly />
          </div>
        )}
        <div className="mt-8 flex flex-wrap items-center gap-4">
          <Link to="/chat" className="hv-btn-light" data-testid="share-ask-own-button">Ask Ceres your own question</Link>
          <BriefDialog messageId={id} trigger={<button type="button" className="hv-btn-light" data-testid="share-brief-button">Download advisor brief (PDF)</button>} />
          <a href="https://harvestportfolios.com/contact-us/" target="_blank" rel="noreferrer" className="text-[13px] text-hv-logo-navy underline">Contact Harvest</a>
        </div>
      </main>
    </div>
  );
}
